import 'es6-promise/auto';
import * as React from 'react';
import * as _ from 'lodash';

import { connect } from 'react-redux';
import * as DirectoryActions from './actions';
import { IMember, IDirectoryState } from './classes';

import DirectoryFiltersReset from './filters/directory-filters-reset';
import DirectoryFilters from './filters/directory-filters';
import DirectoryPagination from './directory-pagination';
import DirectoryDisplay from './directory-display';
import { pushInUrlQuery, multiPushInUrlQuery } from 'react-url-query';
import * as qs from 'query-string';
import { setMemberNameFilter, setBusinessNameFilter, setCategoryFilter } from './actions';
import { directoryDispatch } from './affiliate-directory';

interface IDirectoryContainerState {
    membersData: any;
    hiddenClass: string;
    inverseHiddenClass: string;
}

interface IQueryProps {
    name: string;
    business: string;
    category: string;
}

class DirectoryContainer extends React.Component<IDirectoryState<IMember>, IDirectoryContainerState> {
    private categoryList;
    private pageSize = 10;

    constructor(props) {
        super(props);

        this.props = props;

        this.categoryList = _.uniq(_.flatMap(this.props.memberList, (member) => { return member.categoryList; }));

        this.state = {
            membersData: null,
            hiddenClass: 'directory-filters-closed',
            inverseHiddenClass: 'directory-fitlers-open',
        }
    }

    componentDidMount() {
        this.parseQuery();
        document.getElementById('directoryLoader').classList.add('affiliate-directory-loader-hide');
    }

    componentDidUpdate() {
        multiPushInUrlQuery({
            name: this.props.nameFilter,
            business: this.props.businessFilter,
            category: this.props.categoryFilter,
        });
    }

    parseQuery = () => {
        let name = this.props.nameFilter;
        let business = this.props.businessFilter;
        let category = this.props.categoryFilter;

        const queryProps = this.queryProps;

        if (queryProps.name) {
            name = queryProps.name;
        }

        if (queryProps.business) {
            business = queryProps.business;
        }

        if (queryProps.category) {
            category = queryProps.category;
        }

        directoryDispatch()(setMemberNameFilter(name));
        directoryDispatch()(setBusinessNameFilter(business));
        directoryDispatch()(setCategoryFilter(category));
    }

    get queryProps(): IQueryProps {
        return qs.parse(window.location.search) as any as IQueryProps;
    }


    addClassName() {
        if (this.state.hiddenClass === 'directory-filters-closed') {
            this.setState({
                hiddenClass: 'directory-filters-open',
                inverseHiddenClass: 'directory-filters-closed'
            });
        } else {
            this.setState({
                hiddenClass: 'directory-filters-closed',
                inverseHiddenClass: 'directory-filters-open'
            });
        }
    }

    render() {
        var filteredMemberList = [];

        // sort filtered list alphabetically
        filteredMemberList = this.props.memberList.sort(function (x, y) {
            if (x.lastName < y.lastName) return -1;
            if (x.lastName > y.lastName) return 1;
            return 0;
        });

        if (this.props.nameFilter.length > 0) {
            filteredMemberList = filteredMemberList.filter((member) => {
                return member.name.toLowerCase().indexOf(this.props.nameFilter.toLowerCase()) >= 0;
            })
        }

        if (this.props.businessFilter.length > 0) {
            filteredMemberList = filteredMemberList.filter((member) => {
                return member.companyName.toLowerCase().indexOf(this.props.businessFilter.toLowerCase()) >= 0;
            })
        }

        if (this.props.categoryFilter.length > 0) {
            if (this.props.categoryFilter != "Select a Category") {
                filteredMemberList = filteredMemberList.filter((member) => {
                    return member.categoryList.map(x => x != null && x != undefined && x.toLowerCase()).indexOf(this.props.categoryFilter) >= 0;
                })
            }
        }

        return (
            <div className="affiliate-directory-container">
                <div className="affiliate-content">

                    <section className="affiliate-filters-container">
                        <div className="affiliate-filters-title">

                            <div className="affiliate-filters-title-inner">
                                <a className={this.state.inverseHiddenClass} onClick={this.addClassName.bind(this)}>
                                    <svg className="svg-icon" aria-hidden="true" focusable="false">
                                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-refiner" />
                                    </svg>
                                    <span className="text">
                                        <span className="visually-hidden">Filter icon</span>
                                    </span>
                                </a>

                                <a className={this.state.hiddenClass} onClick={this.addClassName.bind(this)}>
                                    <svg className="svg-icon directory-icon-close" aria-hidden="true" focusable="false">
                                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-close" />
                                    </svg>
                                    <span className="text">
                                        <span className="visually-hidden">Close filters dropdown</span>
                                    </span>
                                </a>

                                <a className="affiliate-filters-link" id="filters-toggle" onClick={this.addClassName.bind(this)}>
                                    <h5>Filters</h5>
                                </a>
                            </div>

                            <DirectoryFiltersReset />
                        </div>

                        <div className={this.state.hiddenClass}>
                            <DirectoryFilters selectedNameFilter={this.props.nameFilter} selectedBusinessFilter={this.props.businessFilter} categoryList={this.categoryList} selectedCategoryFilter={this.props.categoryFilter} />
                        </div>
                    </section>

                    <DirectoryDisplay baseModel={this.props} pageSize={this.pageSize} updatedList={filteredMemberList} />

                    <DirectoryPagination resultsCount={filteredMemberList.length} currentPage={this.props.currentPage} pageCount={Math.floor((filteredMemberList.length / this.pageSize) + ((filteredMemberList.length % this.pageSize) > 0 ? 1 : 0))} />
                </div>
            </div>
        )
    }
}

export default connect((state) => state)(DirectoryContainer);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/affiliate-directory/directory-container.tsx